/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-15 09:49:27
 */
import {defineStore} from 'pinia';
import { ref } from 'vue';

export const useTagsView = defineStore('tagsView',()=>{
    let visitedViews = ref([])
    let cachedViews = ref([])

    // 添加
    const addViews = (view) =>{
        // console.log('这是store里的view',visitedViews.value)
        const hasView = visitedViews.value.some(i=>i.path == view.path)
        if(hasView) return
            visitedViews.value.push(view)

        if(!view.noCache)
            cachedViews.value.push(view)
    }


    return {
        visitedViews,
        cachedViews,
        addViews
    }
})